import React, { useState } from 'react';
import './styles.css';

export const WideAlert = ({ children, className, iconClear = true }) => {
  const [visible, setVisible] = useState(true);

  return (
    visible && (
      <div className={`wide-alert ${className}`}>
        {iconClear && (
          <button className="close-button" onClick={() => setVisible(false)}>
            <i className="icon-clear ts-20" />
          </button>
        )}
        {children}
      </div>
    )
  );
};
